<template>
  <div class="pagamentos">
    <va-card class="chart-widget" title="Renovações nos ultimos 30 dias">
      <line-chart class="chart" :chart-data="paymentsData" :options="options"/>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import LineChart from '../../reports/LineChart.js'
export default {
  name: 'Pagamentos',
  components: { LineChart },
  methods: {
  },
  data () {
    return {
      pagamentos: [],
      payments: [],
      paymentsData: [],
      loading: false,
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          bodyFontSize: 14,
          bodyFontFamily: 'sans-serif',
        //   enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              stepSize: 2,
            },
          }],
        },
      },
    }
  },
  apollo: {
    pagamentos: {
      query: gql`
      query MyQuery {
        pagamentos: list_payments_last_30_days {
          data
          value
        }
      }
      `,
      result ({ data, loading }) {
        const moment = this.$moment
        if (!loading && Object.keys(data).includes('pagamentos')) {
          this.pagamentos = data.pagamentos
          this.payments = data.pagamentos.map(c => {
            return { x: c.data, y: c.value }
          })
          this.paymentsData = {
            labels: this.payments.map(c => { return moment(c.x).format('DD/MM/YYYY') }), // months.splice(firstMonthIndex, size),
            datasets: [
              {
                backgroundColor: '#f2e5e680',
                borderColor: '#943435',
                data: this.payments,
                tension: 0,
              },
            ],
          }
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('pagamentos')) {
      this.$apollo.queries.pagamentos.refetch()
    }
  },
}
</script>

<style lang="scss">
.chart-widget {
  .va-card__body {
    height: 300px;
  }
}

.chart {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > * {
    height: 100%;
    width: 100%;
  }

  canvas {
    width: 100%;
    height: auto;
  }
}
</style>
